import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const online = {
	// 获取用户在线简历
	getOnlineCv: token => {
		return api.get(proxyApi + `/v3/cv_accounts/${ token }/online_cv`)
	},
	checkIntegrity: payload => {
		return api.get(proxyApi + `/v3/cvs/${ payload }/complete_infos`)
	},
	// 获取用户基本信息
	getCvBasicInfo: payload => {
		return api.get(proxyApi + `/v3/cv_accounts/${ payload }/basic_info`)
	},
	// 获取手机号验证码
	getPhoneValidateCode: (payload, token) => {
		return api.get(proxyApi + `/v3/cv_accounts/${ token }/phone_validate_code`, payload)
	},
	// 验证手机号码
	verifyPhoneCode: (payload, token) => {
		return api.post(proxyApi + `/v3/cv_accounts/${ token }/phone_validate_code`, payload)
	},
	// 创建用户基本信息
	createBasicInfo: (payload, token) => {
		return api.post(proxyApi + `/v3/cv_accounts/${ token }/basic_info`, payload)
	},
	// 创建在线简历
	createOnlineCv: payload => {
		return api.post(proxyApi + `/v3/online_cvs`, payload)
	},
	// 获取在线简历私密度
	getVisibility: token => {
		return api.get(proxyApi + `/v3/cv_accounts/${ token }/cv_visibility`)
	},
	// 更新在线简历私密度
	updateVisibility: (payload, token) => {
		return api.put(proxyApi + `/v3/cv_accounts/${ token }/cv_visibility`, payload)
	}
}

export default online
